const t = {
  name: "DayNight",
  dimensions: { width: 40, height: 41 },
  content: `
    <svg fill="currentColor">
    <g clip-path="url(#clip0_27_2128)">
    <path d="M2.00098 20.0029C2.00098 10.4129 9.54098 2.57293 19.001 2.05293V37.9529C9.54098 37.4329 2.00098 29.5929 2.00098 20.0029ZM21.001 19.0029V16.9429H37.721C37.841 17.6229 37.911 18.3029 37.951 19.0029H21.001ZM21.001 23.0029V21.0029H37.951C37.911 21.6829 37.841 22.3429 37.731 23.0029H21.001ZM21.001 27.0029V25.0029H37.281C37.081 25.6829 36.861 26.3529 36.581 27.0029H21.001ZM21.001 31.0029V29.0029H35.561C35.151 29.7029 34.701 30.3729 34.211 31.0029H21.001ZM21.001 35.0029V33.0029H32.421C31.651 33.7429 30.821 34.4129 29.931 35.0029H21.001ZM21.001 37.0029H25.861C24.321 37.5329 22.691 37.8629 21.001 37.9529V37.0029ZM21.001 3.00293V2.05293C22.691 2.14293 24.321 2.47293 25.861 3.00293H21.001ZM21.001 7.00293V5.00293H29.931C30.821 5.59293 31.651 6.26293 32.421 7.00293H21.001ZM21.001 11.0029V9.00293H34.221C34.711 9.63293 35.161 10.3029 35.571 11.0029H21.001ZM21.001 13.0029H36.581C36.851 13.6329 37.071 14.2829 37.261 14.9429H21.001V13.0029ZM20.001 0.00292969C8.97098 0.00292969 0.000976562 8.97293 0.000976562 20.0029C0.000976562 31.0329 8.97098 40.0029 20.001 40.0029C31.031 40.0029 40.001 31.0329 40.001 20.0029C40.001 8.97293 31.031 0.00292969 20.001 0.00292969Z" />
    </g>
    <defs>
    <clipPath id="clip0_27_2128">
    <rect width="40" height="40" fill="currentColor" transform="translate(0.000976562 0.00292969)"/>
    </clipPath>
    </defs>
    </svg>
  `
};
export {
  t as DayNight
};
